<template>
    <div class="w-full">
        <div class="w-full grid grid-cols-1 md:grid-cols-12 gap-8" v-if="event && !isLoading">
            <!-- Event Poster -->
            <div class="md:col-span-4">
                <img :src="event.poster" :alt="event.name" class="rounded-lg w-full shadow-lg object-cover"
                    loading="lazy" />
            </div>

            <!-- Event Details -->
            <div class="md:col-span-8 space-y-4">
                <!-- Title -->
                <h1 class="text-white font-bold text-3xl md:text-4xl">
                    {{ event.name }}
                </h1>

                <!-- Description -->
                <p class="text-nomad-200 font-light text-md leading-relaxed">
                    {{ event.description }}
                </p>

                <!-- Details Cards -->
                <div class="space-y-3 pt-4">
                    <!-- Location -->
                    <a href="#" @click.prevent="openMap"
                        class="flex items-center gap-3 p-3 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-md transition-all duration-300">
                        <span class="icon-navigation text-nomad-accent text-xl flex-shrink-0"></span>
                        <div class="flex-1 min-w-0">
                            <p class="text-nomad-200 font-semibold text-sm">{{ event.venue }}</p>
                            <p class="text-nomad-300 text-xs">
                                {{ event.street }}, {{ event.city }} {{ event.postal_code }}, {{ event.country.name }}
                            </p>
                        </div>
                    </a>

                    <!-- Price -->
                    <div class="flex items-center gap-3 p-3 rounded-lg bg-nomad-800">
                        <span class="icon-dollar-sign text-nomad-accent text-xl flex-shrink-0"></span>
                        <span class="text-nomad-200 font-semibold">{{ event.price }}</span>
                    </div>

                    <!-- Date -->
                    <div class="flex items-center gap-3 p-3 rounded-lg bg-nomad-800">
                        <span class="icon-calendar text-nomad-accent text-xl flex-shrink-0"></span>
                        <span class="text-nomad-200 font-semibold">{{ event.date_at_formated }}</span>
                    </div>

                    <!-- Artists -->
                    <div v-if="event.artists.length > 0" class="pt-2">
                        <div class="flex items-center gap-3 p-3 rounded-lg bg-nomad-800">
                            <span class="icon-users text-nomad-accent text-xl flex-shrink-0"></span>
                            <div class="flex items-center gap-3 flex-1 min-w-0 overflow-x-auto">
                                <div v-for="artist in event.artists" :key="artist.id"
                                    class="flex items-center gap-2 flex-shrink-0">
                                    <img v-if="artist.image" :src="artist.image" :alt="artist.name"
                                        class="h-8 w-8 rounded-full object-cover" />
                                    <span class="text-nomad-200 font-semibold text-sm whitespace-nowrap">{{ artist.name
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Buy Ticket Button -->
                    <a v-if="event.ticket_url" :href="event.ticket_url" target="_blank"
                        class="flex items-center gap-3 p-3 rounded-lg bg-nomad-accent hover:bg-nomad-accent/80 text-nomad-900 font-semibold transition-all hover:shadow-lg duration-300">
                        <span class="icon-tag text-lg"></span>
                        <span>Get Tickets</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
defineProps({ event: Object });
</script>
<script>
import { mapState, mapActions } from "vuex";
import { usePage } from "@inertiajs/vue3";
import { defineAsyncComponent } from 'vue'
const { join } = defineAsyncComponent(() => import('lodash'))


export default {
    methods: {
        ...mapActions("event", ["getSignleEvent"]),
        openMap() {
            let address = [
                this.event.street,
                this.event.city,
                this.event.country.name,
                this.event.postal_code,
            ];

            address = join(address, "+");

            window.open("http://maps.google.com/?daddr=" + address, "_blank");
        },
    },
    created() {
        // const id = usePage().props.query.id;
        // console.og(id)
        // this.getSignleEvent(id);
    },
    computed: {
        ...mapState({ event: (state) => state.event.single }),
        ...mapState({ isLoading: (state) => state.event.isLoading }),
    },

    components: {
        'featured-artist': defineAsyncComponent(() => import("@/components/FeaturedArtist.vue")),
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    },
    created() {
        document.title = this.event.name + " Event"
    },
};
</script>
